import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import useProductCustomerPhotosReviewsMin from 'data-hooks/useProductCustomerPhotosReviews/useProductCustomerPhotosReviewsMin';
import usePDPFabricFilters from 'data-hooks/usePDPFabricFilters';
import useProductCustomerPhotosReviews from 'data-hooks/useProductCustomerPhotosReviews';
import useModularPDPCustomerPhotosAndReviews from 'data-hooks/useModularPDPCustomerPhotosAndReviews';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import { useBazaarVoiceEnabled } from 'hooks/useBazaarVoice';
import PDPCustomerPhotosUI from './PDPCustomerPhotosUI';
import BVPDPCustomerPhotosUI from './BVPDPCustomerPhotosUI';
import usePdpIsModularBYOProduct from '../state/context/usePdpIsModularBYOProduct';
const PDPCustomerPhotosInner = t0 => {
  const $ = _c(12);
  const {
    slug
  } = t0;
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const {
    loading,
    error,
    data
  } = useProductCustomerPhotosReviewsMin();
  const initialModularCustomerData = useModularPDPCustomerPhotosAndReviews();
  let t1;
  if ($[0] !== initialModularCustomerData || $[1] !== pdpIsModularBYOProduct) {
    t1 = pdpIsModularBYOProduct ? {} : initialModularCustomerData;
    $[0] = initialModularCustomerData;
    $[1] = pdpIsModularBYOProduct;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const modularCustomerData = t1;
  const {
    data: t2
  } = usePDPFabricFilters(slug, false);
  const {
    selectedMaterial
  } = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      ssr: false
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useProductCustomerPhotosReviews(data?.id, t3);
  if (loading) {
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <PDPCustomerPhotosUI loading={true} />;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  if (error) {
    return "Something went wrong, please try again";
  }
  if (!data) {
    return null;
  }
  const {
    id,
    name
  } = data;
  const {
    customer_photos_min,
    customer_reviews
  } = pdpIsModularBYOProduct ? modularCustomerData : data;
  let t4;
  if ($[5] !== customer_photos_min || $[6] !== customer_reviews || $[7] !== id || $[8] !== name || $[9] !== pdpIsModularBYOProduct || $[10] !== selectedMaterial) {
    t4 = <PDPCustomerPhotosUI id={id} name={name} customerReviews={customer_reviews} customerPhotos={customer_photos_min} pdpIsModularBYOProduct={pdpIsModularBYOProduct} selectedMaterial={selectedMaterial} />;
    $[5] = customer_photos_min;
    $[6] = customer_reviews;
    $[7] = id;
    $[8] = name;
    $[9] = pdpIsModularBYOProduct;
    $[10] = selectedMaterial;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
PDPCustomerPhotosInner.propTypes = {
  slug: PropTypes.string
};
const PDPCustomerPhotos = t0 => {
  const $ = _c(3);
  const {
    slug
  } = t0;
  const isBVEnabled = useBazaarVoiceEnabled();
  if (isBVEnabled) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <BVPDPCustomerPhotosUI />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (!slug) {
    return null;
  }
  let t1;
  if ($[1] !== slug) {
    t1 = <SuspenseWithLoader><PDPCustomerPhotosInner slug={slug} /></SuspenseWithLoader>;
    $[1] = slug;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
PDPCustomerPhotos.propTypes = {
  slug: PropTypes.string
};
export default PDPCustomerPhotos;